import React from 'react';
import { useLingui } from '@lingui/react/macro';

import { Box, Heading } from '@rover/kibble/core';
import {
  getIconNameAdapted,
  renderIcon,
} from '@rover/react-lib/src/pages/sitter-profile/SitterProfilePage/utils/utils';
import type { EnhancedPersonSitterProfileAttributes } from '@rover/rsdk/src/apiClient/latest/model/enhancedPersonSitterProfileAttributes';
import type { EnhancedPersonSitterProfileCatAttributes } from '@rover/rsdk/src/apiClient/latest/model/enhancedPersonSitterProfileCatAttributes';

import SkillItem from './SkillItem';

const SkillsList = ({
  attributes,
  heading: headingProp,
}: {
  attributes: EnhancedPersonSitterProfileAttributes | EnhancedPersonSitterProfileCatAttributes;
  heading?: string;
}): JSX.Element | null => {
  const { t } = useLingui();
  const heading = headingProp === undefined ? t`Skills` : headingProp;
  const attributeKeys = Object.keys(attributes);

  if (attributeKeys.length === 0) {
    return null;
  }

  return (
    <Box width="100%">
      <Heading size="300">{heading}</Heading>
      {attributeKeys.map((key) => {
        const { text, icon, key: attributeKey } = attributes[key];

        if (!text) {
          return null;
        }

        const iconRendered = renderIcon(getIconNameAdapted(icon));

        return <SkillItem icon={iconRendered} title={text} key={attributeKey} />;
      })}
    </Box>
  );
};

export default SkillsList;
